import { useLanguage } from '@/contexts/LanguageContext';
import { t } from '@/i18n/translations';

export const Footer = () => {
  const { lang } = useLanguage();
  const tx = t(lang).footer;

  return (
    <footer className="bg-[#07101E] border-t border-white/10 py-10 px-6">
      <div className="max-w-[1200px] mx-auto">

        {/* Mobile: stacked centered / Desktop: side by side */}
        <div className="flex flex-col items-center text-center gap-8 md:flex-row md:items-start md:justify-between md:text-left">

          {/* Brand */}
          <div className="flex flex-col items-center md:items-start">
            <img src="/wibe-logo.png" alt="Wibe Solutions" className="h-16 mb-3" />
            <p className="text-white/50 text-sm leading-relaxed max-w-[260px]">
              {tx.tagline}
            </p>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-end">
            <h4 className="font-mono text-[#C87533] text-xs uppercase tracking-widest mb-3">
              {tx.contactTitle}
            </h4>
            <ul className="space-y-1.5 text-sm">
              <li className="text-white/80 font-semibold">{tx.company}</li>
              <li className="text-white/45">{tx.address1}</li>
              <li className="text-white/45">{tx.address2}</li>
              <li>
                <a href="mailto:info@wibe.si"
                  className="text-[#C87533] hover:text-[#FF8C2A] transition-colors">
                  info@wibe.si
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="section-divider mt-8 mb-5" />

        {/* Bottom bar */}
        <div className="flex flex-col items-center gap-2 sm:flex-row sm:justify-between">
          <p className="text-white/35 text-[11px] font-mono text-center">
            {tx.copyright}
          </p>
          <p className="text-white/25 text-[11px] font-mono text-center">
            {tx.compliance}
          </p>
        </div>

      </div>
    </footer>
  );
};
